import moment from 'moment';
import { Dispatch, SetStateAction, useState } from 'react';
import { FormControl } from '@mui/material';
import { ScheduleSend } from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers';
import Sidebar from "../../../Components/Sidebar/Sidebar";
import SidebarGroup from "../../../Components/Sidebar/SidebarGroup";
import SidebarButton from "../../../Components/Sidebar/SidebarButton";
import NotificationSnackbar from "../../../Components/Layout/NotificationSnackbar";
import useUser from "../../../system/useUser";
import { UserRole } from "../../../system/Domain";
import axios from "axios";
import SidebarForm from "../../../Components/Sidebar/SidebarForm";
import useReportRequestCooldown from "../../../system/useReportRequestCooldown";
import { ValidationSlaQuery } from "../VehicleValidationDashboard";

export interface VehicleValidationDashboardSidebarProps {
	query: ValidationSlaQuery;
	setQuery: Dispatch<SetStateAction<ValidationSlaQuery>>;
}

const VehicleValidationDashboardSidebar = ({ query, setQuery }: VehicleValidationDashboardSidebarProps) => {
	const [, , hasRole] = useUser();
	const [requestReport, requestingExport] = useReportRequestCooldown();
	const [message, setMessage] = useState<string>();

	const requestSlaExport = () => requestReport(async () => {
		await axios.post(`/api/user-reports/validation-sla-export`, {
			dateFrom: query.dateFrom,
		});

		setMessage("Der Report wird erstellt. Sie werden per Mail benachrichtigt, sobald er unter \"Reports\" zum Download bereitsteht.");
	});

	return (
		<Sidebar>
			<SidebarGroup>
				<SidebarForm>
					<FormControl fullWidth>
						<DatePicker
							format="DD.MM.YYYY"
							label="Validiert seit dem"
							value={moment(query.dateFrom)}
							slotProps={{ textField: { variant: 'standard' } }}
							onChange={(d: any) => setQuery(q => ({
								...q,
								dateFrom: (d || moment()).startOf("d").toISOString(true)
							}))}
						/>
					</FormControl>
					<SidebarButton
						startIcon={<ScheduleSend />}
						disabled={!hasRole(UserRole.ValidationAdmin) || requestingExport}
						onClick={requestSlaExport}
						label="SLA-Export"
					/>
				</SidebarForm>
			</SidebarGroup>
			<NotificationSnackbar message={message} onClose={() => setMessage(undefined)} color="success" />
		</Sidebar>
	);
};

export default VehicleValidationDashboardSidebar;
